import * as React from 'react'
import Checkbox from 'apps/Onboarding/components/Checkbox'
import { APP_NAME, APP_WEBSITE_URL_WEBPAGES } from 'utils/constants'
import { IAgreementTermsAndConditions } from './interface'
import { useTranslation } from 'react-i18next'
import './AgreementTermsAndConditions.scss'

const AgreementTermsAndConditions = ({ checked, onChange }: IAgreementTermsAndConditions): JSX.Element => {
  const TERMS_AND_CONDITIONS_URL: string = APP_WEBSITE_URL_WEBPAGES[APP_NAME.onboarding].termsOfService
  const { t } = useTranslation()

  const handleClick = (): void => onChange(!checked)

  return (
    <Checkbox
      linkUrl={TERMS_AND_CONDITIONS_URL}
      text={t('termsAndConditions.agreement')}
      linkText={t('termsAndConditions.title')}
      checked={checked}
      handleChange={handleClick}
    />
  )
}

export default AgreementTermsAndConditions
